import apiClient from "../../services/apiClient";

export async function generateQRCodeAPI(data) {
  const response = await apiClient.post("/api/v1/paper-assignment/generate-qr/", data, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchLevelsAPI() {
  const response = await apiClient.get("/api/v1/paper-assignment/levels/", {
    withAuth: true,
  });
  return response.data;
}

export async function fetchStudentsAPI(levelId = null) {
  let url = "/api/v1/paper-assignment/students/";
  if (levelId) {
    url += `?level_id=${levelId}`;
  }
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function fetchAssignmentsAPI(levelId = null) {
  let url = "/api/v1/paper-assignment/";
  if (levelId) {
    url += `?level_id=${levelId}`;
  }
  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

export async function uploadAssignmentAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/upload/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

export async function deleteAssignmentAPI(s3Key) {
  const response = await apiClient.delete(`/api/v1/paper-assignment/delete/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

export async function downloadAssignmentAPI(s3Key) {
  const response = await apiClient.get(`/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

export async function downloadQRPdfAPI(data) {
  const response = await apiClient.post("/api/v1/paper-assignment/download-qr-pdf/", data, {
    withAuth: true,
    responseType: 'blob', // Important for binary data
  });
  return response;
}

export async function createClassNoticeAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/create-class-notice/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

// 서버가 쪽 단위로 내려준다. 응답은 { results, count, page, page_size, total_pages }.
// dateFrom/dateTo 를 주면 그 기간(달력이 보고 있는 달)만 가져온다.
export async function fetchPaperAssignmentRecordsAPI({
  levelId = null,
  studentId = null,
  page = null,
  pageSize = null,
  dateFrom = null,
  dateTo = null,
} = {}) {
  let url = "/api/v1/paper-assignment/records/";
  const params = new URLSearchParams();

  if (levelId) {
    params.append('level_id', levelId);
  }
  if (studentId) {
    params.append('student_id', studentId);
  }
  if (page) {
    params.append('page', page);
  }
  if (pageSize) {
    params.append('page_size', pageSize);
  }
  if (dateFrom) {
    params.append('date_from', dateFrom);
  }
  if (dateTo) {
    params.append('date_to', dateTo);
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data;
}

// 달력은 보고 있는 달 전체가 필요하다. 한 달이 서버의 쪽 상한을 넘으면 나머지 쪽을 이어 받는다.
// 여기서 끊으면 달력에 기록이 있는 날이 조용히 비어 보인다.
const CALENDAR_PAGE_SIZE = 500;

export async function fetchPaperAssignmentRecordsForRangeAPI({
  levelId = null,
  studentId = null,
  dateFrom,
  dateTo,
}) {
  const firstPage = await fetchPaperAssignmentRecordsAPI({
    levelId,
    studentId,
    dateFrom,
    dateTo,
    page: 1,
    pageSize: CALENDAR_PAGE_SIZE,
  });

  const records = [...firstPage.results];
  for (let page = 2; page <= firstPage.total_pages; page += 1) {
    const nextPage = await fetchPaperAssignmentRecordsAPI({
      levelId,
      studentId,
      dateFrom,
      dateTo,
      page,
      pageSize: CALENDAR_PAGE_SIZE,
    });
    records.push(...nextPage.results);
  }

  return records;
}

export async function deletePaperAssignmentRecordAPI(recordId) {
  const response = await apiClient.delete(`/api/v1/paper-assignment/records/${recordId}/`, {
    withAuth: true,
  });
  return response.data;
}

// 학생 제출물 다운로드 (교사용)
export async function downloadStudentSubmissionAPI(s3Key) {
  const response = await apiClient.get(`/api/v1/paper-assignment/download/${encodeURIComponent(s3Key)}/`, {
    withAuth: true,
  });
  return response.data;
}

// 학생 제출물 채점 및 첨삭 파일 업로드
export async function gradeStudentSubmissionAPI(formData) {
  const response = await apiClient.post("/api/v1/paper-assignment/grade-submission/", formData, {
    withAuth: true,
    headers: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response.data;
}

// 교사의 모든 학생들의 온라인 과제 목록 조회
export async function fetchTeacherStudentsOnlineAssignmentsAPI(levelId = null, studentId = null, isFinished = null) {
  let url = "/api/v1/assignment/list/teacher?page=1&limit=1000";

  if (levelId) {
    url += `&level_id=${levelId}`;
  }
  if (studentId) {
    url += `&student_id=${studentId}`;
  }
  if (isFinished !== null) {
    url += `&is_finished=${isFinished ? 'true' : 'false'}`;
  }

  const response = await apiClient.get(url, {
    withAuth: true,
  });
  return response.data.results || [];
}

// 해설지 PDF 다운로드
export async function retrieveCommentaryPDFAPI(assignmentId, studentId) {
  const response = await apiClient.get(
    `/api/v1/assignment/pdf/commentary?assignment_id=${assignmentId}&student_id=${studentId}`,
    { responseType: "blob" }
  );
  return response;
}